// extracted by mini-css-extract-plugin
module.exports = {"table":"DepartmentReportProjects_table__14Eil","title":"DepartmentReportProjects_title__1ybJu"};